module.exports = __webpack_public_path__ + "static/media/icon-title-history.4749b91d.png";